// extracted by mini-css-extract-plugin
export default {"empty":"collection_empty__JL8tg","collectionList":"collection_collectionList__cbOt1","showAll":"collection_showAll__+RSQh"};